import { Icon } from '@iconify/react';
import IdVerificationIcon from './IdVerificationIcon';

export const SIDE_NAV_CUSTOM_ICON = 'idVerification' as const;

/** Phosphor iconify id (e.g. `ph:users-bold`) or the custom ID verification icon. */
export type SideNavIconName = typeof SIDE_NAV_CUSTOM_ICON | `ph:${string}` | `stash:${string}`;

interface Props {
    icon: SideNavIconName;
    size?: number;
}

export default function SideNavIcon({ icon, size = 24 }: Props) {
    if (icon === SIDE_NAV_CUSTOM_ICON) {
        return <IdVerificationIcon size={size} />;
    }
    return <Icon icon={icon} width={size} height={size} />;
}
